import _objectDestructuringEmpty from "@babel/runtime/helpers/objectDestructuringEmpty";
import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import Modal from '@blaze-react/modal';
import ReactDOM from 'react-dom';
import { usePortal } from '../../hooks';
const ModalAdapter = _ref => {
  let props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  const target = usePortal();
  return ReactDOM.createPortal( /*#__PURE__*/React.createElement(Modal, props), target);
};
export default ModalAdapter;
//# sourceMappingURL=ModalAdapter.js.map